import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRecommendationItemsQueryVariables = Types.Exact<{
  date: Types.Scalars['Date']['input'];
  sensorName: Types.Scalars['String']['input'];
}>;


export type GetRecommendationItemsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly recommendationItems: ReadonlyArray<{ readonly __typename?: 'YalperRecommendationItem', readonly account?: string | null, readonly accountId?: string | null, readonly ad?: string | null, readonly adGroup?: string | null, readonly adGroupId?: string | null, readonly adId?: string | null, readonly adName?: string | null, readonly adsetId?: string | null, readonly application?: string | null, readonly applicationId?: string | null, readonly campaign?: string | null, readonly campaignId?: string | null, readonly fFeedId?: string | null, readonly firstDate?: string | null, readonly isNew?: boolean | null, readonly keyword?: string | null, readonly keywordId?: string | null, readonly sitelink?: string | null, readonly sitelinkId?: string | null, readonly objects?: { readonly __typename?: 'YalperRecommendationItemObjects', readonly age?: { readonly __typename?: 'YalperRecommendationItemObjectDetail', readonly name?: string | null, readonly type?: string | null, readonly value?: string | null } | null, readonly autotargetingBidSearch?: { readonly __typename?: 'YalperRecommendationItemObjectDetail', readonly name?: string | null, readonly type?: string | null, readonly value?: string | null } | null, readonly campaignKind?: { readonly __typename?: 'YalperRecommendationItemObjectDetail', readonly name?: string | null, readonly type?: string | null, readonly value?: string | null } | null, readonly correction?: { readonly __typename?: 'YalperRecommendationItemObjectDetail', readonly name?: string | null, readonly type?: string | null, readonly value?: string | null } | null, readonly finalUrl?: { readonly __typename?: 'YalperRecommendationItemObjectDetail', readonly name?: string | null, readonly type?: string | null, readonly value?: string | null } | null, readonly gender?: { readonly __typename?: 'YalperRecommendationItemObjectDetail', readonly name?: string | null, readonly type?: string | null, readonly value?: string | null } | null, readonly link?: { readonly __typename?: 'YalperRecommendationItemObjectDetail', readonly name?: string | null, readonly type?: string | null, readonly value?: string | null } | null, readonly linkType?: { readonly __typename?: 'YalperRecommendationItemObjectDetail', readonly name?: string | null, readonly type?: string | null, readonly value?: string | null } | null, readonly metric?: { readonly __typename?: 'YalperRecommendationItemObjectDetail', readonly name?: string | null, readonly type?: string | null, readonly value?: string | null } | null, readonly metricDiffAbs?: { readonly __typename?: 'YalperRecommendationItemObjectDetail', readonly name?: string | null, readonly type?: string | null, readonly value?: string | null } | null, readonly metricLimit?: { readonly __typename?: 'YalperRecommendationItemObjectDetail', readonly name?: string | null, readonly type?: string | null, readonly value?: string | null } | null, readonly metricValue?: { readonly __typename?: 'YalperRecommendationItemObjectDetail', readonly name?: string | null, readonly type?: string | null, readonly value?: string | null } | null, readonly period?: { readonly __typename?: 'YalperRecommendationItemObjectDetail', readonly name?: string | null, readonly type?: string | null, readonly value?: string | null } | null, readonly placement?: { readonly __typename?: 'YalperRecommendationItemObjectDetail', readonly name?: string | null, readonly type?: string | null, readonly value?: string | null } | null, readonly targetLoc?: { readonly __typename?: 'YalperRecommendationItemObjectDetail', readonly name?: string | null, readonly type?: string | null, readonly value?: string | null } | null } | null }> } | null } | null };


export const GetRecommendationItemsDocument = gql`
    query GetRecommendationItems($date: Date!, $sensorName: String!) {
  currentUser {
    currentCompany {
      recommendationItems(date: $date, sensorName: $sensorName) {
        account
        accountId
        ad
        adGroup
        adGroupId
        adId
        adName
        adsetId
        application
        applicationId
        campaign
        campaignId
        fFeedId
        firstDate
        isNew
        keyword
        keywordId
        objects {
          age {
            name
            type
            value
          }
          autotargetingBidSearch {
            name
            type
            value
          }
          campaignKind {
            name
            type
            value
          }
          correction {
            name
            type
            value
          }
          finalUrl {
            name
            type
            value
          }
          gender {
            name
            type
            value
          }
          link {
            name
            type
            value
          }
          linkType {
            name
            type
            value
          }
          metric {
            name
            type
            value
          }
          metricDiffAbs {
            name
            type
            value
          }
          metricLimit {
            name
            type
            value
          }
          metricValue {
            name
            type
            value
          }
          period {
            name
            type
            value
          }
          placement {
            name
            type
            value
          }
          targetLoc {
            name
            type
            value
          }
        }
        sitelink
        sitelinkId
      }
    }
  }
}
    `;

/**
 * __useGetRecommendationItemsQuery__
 *
 * To run a query within a React component, call `useGetRecommendationItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendationItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendationItemsQuery({
 *   variables: {
 *      date: // value for 'date'
 *      sensorName: // value for 'sensorName'
 *   },
 * });
 */
export function useGetRecommendationItemsQuery(baseOptions: Apollo.QueryHookOptions<GetRecommendationItemsQueryPage, GetRecommendationItemsQueryVariables> & ({ variables: GetRecommendationItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecommendationItemsQueryPage, GetRecommendationItemsQueryVariables>(GetRecommendationItemsDocument, options);
      }
export function useGetRecommendationItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecommendationItemsQueryPage, GetRecommendationItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecommendationItemsQueryPage, GetRecommendationItemsQueryVariables>(GetRecommendationItemsDocument, options);
        }
export function useGetRecommendationItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecommendationItemsQueryPage, GetRecommendationItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecommendationItemsQueryPage, GetRecommendationItemsQueryVariables>(GetRecommendationItemsDocument, options);
        }
export type GetRecommendationItemsQueryHookResult = ReturnType<typeof useGetRecommendationItemsQuery>;
export type GetRecommendationItemsLazyQueryHookResult = ReturnType<typeof useGetRecommendationItemsLazyQuery>;
export type GetRecommendationItemsSuspenseQueryHookResult = ReturnType<typeof useGetRecommendationItemsSuspenseQuery>;
export type GetRecommendationItemsQueryResult = Apollo.QueryResult<GetRecommendationItemsQueryPage, GetRecommendationItemsQueryVariables>;